<mat-card appearance="outlined" [ngClass]="{'disabled': isCardFadedOut}">
  <div class="event-card-image image-blur" [ngStyle]="{'background-image': image}">
    <app-s3-downloader *ngIf="event.boEvent && event.image" [model]="event.image" [type]="S3UploaderTypes.Event" [ratio]="S3UploaderRatios.Modern"
                       [ownerCentreId]="event.externalOwnerCentreId" [ownerId]="event.eventId" [noBorder]="true" [customContainer]="true" [backgroundBased]="true"></app-s3-downloader>
  </div>
  <div class="self-service-icon" *ngIf="event.boEvent">
    <mat-icon class="svg-icon" [svgIcon]="'salespoints_outlined'"></mat-icon>
  </div>
  <div class="badge event-badge" *ngIf="isPresaleEnded">{{ 'general.api_sales_pre_sale_ended' | translate }}</div>
  <div class="badge event-badge accent" *ngIf="isSaleStartsOn">
    {{ 'general.api_sales_sale_start_on' | translate}} {{ event.sale.start | moment: { withTime: true } }}
  </div>
  <div class="badge event-badge warning" *ngIf="needsWarningBadge">
    {{ warningBadgeText | translate }}
  </div>
  <mat-card-content>
    <div class="text-secondary body-3 white-space-no-wrap bold">
      {{ event.event | period: {hasTimeInPeriod: true} }}
    </div>
    <div class="heading-5 two-line-overflow no-margin">{{ event.title }}</div>
    <div class="two-line-overflow text-grey">
      <span *ngIf="event.venueTitle">{{ event.venueTitle }}</span>
      <span *ngIf="event.venueTitle && event.onlineLocation">,&nbsp;</span>
      <span *ngIf="event.onlineLocation">{{ event.onlineLocation }}</span>
    </div>
  </mat-card-content>
  <mat-card-actions (mouseenter)="actionsDisabled = false" (mouseleave)="actionsDisabled = true">
    <div class="actions-wrapper">
      <button mat-flat-button color="primary" *ngIf="eventService.displaySaleActions(event)" (click)="openPurchaseView.emit(event)"
              [disabled]="eventService.isPurchaseViewDisabled(event, cartService.cartDraftEvent) || mobileActionsDisabled">
        <ng-container *ngIf="canBuy">{{'general.api_sales_buy_now' | translate}}</ng-container>
        <ng-container *ngIf="isPresaleWithCode">{{'general.api_sales_pre_sale_with_code' | translate}}</ng-container>
        <ng-container *ngIf="isTicketsUnavailable">{{'general.api_sales_tickets_unavailable' | translate}}</ng-container>
        <ng-container *ngIf="isSoldOut && !authService.hasRefundExchangePrivilege">{{'general.api_sales_open_details' | translate}}</ng-container>
      </button>
      <button mat-flat-button color="primary" *ngIf="eventService.displayRefundActions(event)" (click)="openPurchaseView.emit(event)"
              [disabled]="eventService.isPurchaseViewDisabled(event, cartService.cartDraftEvent) || mobileActionsDisabled">
        <ng-container *ngIf="isRefundable && !event.substatusId">{{'general.api_sales_refund' | translate}}</ng-container>
        <ng-container *ngIf="isSoldOut && authService.hasRefundExchangePrivilege">{{'general.api_sales_exchange_tickets' | translate}}</ng-container>
      </button>
      <button mat-flat-button color="primary" [disabled]="mobileActionsDisabled"
              (click)="openEventDetails.emit(event)" (mouseover)="actionsDisabled = false" (mouseout)="actionsDisabled = true">
        {{'general.api_general_read_more' | translate}}
      </button>
      <button mat-flat-button color="primary" [disabled]="mobileActionsDisabled" *ngIf="!event.boEvent && authService.hasBookingViewPrivilege"
              (click)="openEventBookings.emit(event)">
        {{'general.api_open_event_bookings' | translate}}
      </button>
    </div>
  </mat-card-actions>
</mat-card>
